(function (algolia) {
  'use strict';

  algolia.translations = {
    search: "Ta recherche",
    noCollectionFound: "Pas de collection correspondante",
    allProducts: "Voir tous les produits",
    matching: "correspondant à",
    sortBy: "Trier par",
    relevance: "Pertinence",
    outOf: "sur",
    resultsFound: "résultats",
    oneResultFound: "1 résultat",
    noResultFound: "Aucun résultat",
    addToCart: "Ajouter au panier",
    searchForProduct: "Rechercher des produits...",
    selectedFilter: "Filtrer",
    clearAll: "Tout effacer",
  };

  algolia.translation_helpers = {
    no_result_for: function (text, render) {
      return 'Pas de résultat pour ' + render(text) + '';
    },
    in: function (text, render) {
      return 'dans ' + render(text) + 's';
    },

    try_clear_or_change_input: function (text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return 'Essai ' + render(html_tags[0]) + ' clearing filters ' + render(html_tags[1]) + ' ou ' + render(html_tags[2]) + ' changing your input ' + render(html_tags[3]) + '';
    },
    outOf: function (text, render) {
      return '' + render(text) + ' sur';
    },

    by: function (text, render) {
      /*return 'by ' + render(text) + '';*/
      return '';
    }
  };


}(algoliaShopify));
